import { render, staticRenderFns } from "./TxDetail.vue?vue&type=template&id=4ea98cb1&scoped=true&"
import script from "./TxDetail.vue?vue&type=script&lang=js&"
export * from "./TxDetail.vue?vue&type=script&lang=js&"
import style0 from "./TxDetail.vue?vue&type=style&index=0&id=4ea98cb1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea98cb1",
  null
  
)

export default component.exports